<template>

<b-modal :id="`pharmacyDispenser-${key}`" :title="title" no-close-on-backdrop hide-footer>

	<div v-if="!showForm">
		<FormulateInput
			label="Usuario dispensador"
			validation-name="Usuario"
			v-model="selectedUser"
			type="selectAsync"
			option-value="id"
			option-text="name"
			:options="dispensers"
			@create="createNew"
			placeholder="Seleccione un usuario"
			createButtonText="Crear usuario nuevo"
			validation="required"
		/>

		<div class="btn btn-success" @click="select" >Seleccionar</div>
	</div>
	
	<PharmacyDispenserForm v-if="showForm" :id="id" @created="upserted" @updated="upserted" @close="showForm=false" @deleted="deleted"/>


</b-modal>

</template>

<script>
import gql from 'graphql-tag'
import PharmacyDispenserForm from './PharmacyDispenserForm'

export default {
	name: 'PatientModalForm',
	components:{
		PharmacyDispenserForm,
	},
	data() {
		return {
			title: 'Seleccionar usuario dispensador',
			id: null,
			selectedUser:null,
			dispensers:[],
			showForm:false,
			key: Math.random()
		}
	},
	methods:{
		async upserted(data){
			await this.fetchData()
			this.showForm = false
			this.selectedUser = data
		},
		select(){
			if(this.selectedUser){
				this.$emit('upserted', this.selectedUser)
				this.close()
			}
		},
		deleted(){
			this.$emit('deleted')
			this.close()
		},
		async open(id){
			await this.fetchData()
			if(id) this.title = 'Editar usuario dispensador'
			this.id = id
			this.$bvModal.show(`pharmacyDispenser-${this.key}`)
		},

		close(){
			this.id = null
			this.$bvModal.hide(`pharmacyDispenser-${this.key}`)
		},


		createNew(){
			this.showForm = true
		},

		fetchData(){
			return this.$apollo.query({
				query: gql`query {
					pharmacyLogged {
						id
						dispensers{
							id name
						}
					}
				}`,
				fetchPolicy: 'network-only',
			})
			.then(({data}) => {
				this.dispensers = data.pharmacyLogged.dispensers
			})
			.catch((err)=>{
				console.log(err)
			})

		},

	}
}


</script>

<style>

</style>
